import React from 'react'
import { AdCreative } from '@marketing-milk/interfaces'
import { Drawer } from '@mui/material'
import { addOrRemove } from 'app/util'
import { Step } from 'components/Stepper'
import { Stepper } from 'components/Stepper/Stepper'
import { useSprint } from 'hooks/api/useSprint'
import { BulkCreativeSelect } from 'pages/business/creatives/components/bulk-operations/BulkSelect'
import { CreativeCard } from 'pages/business/creatives/CreativeCard/CreativeCard'
import { useState } from 'react'

type Props = {
  sprintId: number
  open: boolean
  onClose: () => void
}
export const BulkImportCreatives = (props: Props) => {
  const [selectedCreatives, setSelectedCreatives] = useState<AdCreative[]>([])
  const { importCreativesToSprint } = useSprint(props.sprintId)
  const onSelectCreative = (creative: AdCreative) =>
    setSelectedCreatives(prev => addOrRemove(creative, prev))

  const onComplete = () => {
    importCreativesToSprint(selectedCreatives)
    props.onClose()
  }

  return (
    <Drawer open={props.open} onClose={props.onClose}>
      <div style={{ width: '80vw' }}>
        <Stepper submitButtonText="Copy to sprint">
          <Step title="Copy existing creatives">
            <div className="w-full flex flex-col max-w-7xl mx-auto p-4 space-y-4">
              <h1 className="py-2 font-lg font-bold mx-auto">Select creatives to copy</h1>
            </div>
            <div>
              <BulkCreativeSelect
                onSelectCreative={onSelectCreative}
                selectedCreatives={selectedCreatives}
              />
            </div>
          </Step>
          <Step title="Confirm" onNext={onComplete}>
            <div className="w-full flex flex-col max-w-7xl mx-auto p-4 space-y-4">
              <h1 className="py-2 font-lg font-bold mx-auto">
                New copies will be added to this sprint. The originals will stay unchanged.
              </h1>
            </div>
            <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(20rem,1fr))] gap-5">
              {selectedCreatives.map(creative => (
                <CreativeCard
                  key={creative.id}
                  tools={false}
                  creative={creative}
                  onSelect={() => {}}
                />
              ))}
            </div>
          </Step>
        </Stepper>
      </div>
    </Drawer>
  )
}
